<template>
  <SharedTileDisplay
    :autoplay="mgnlProps.autoplay"
    :autoplay-time="mgnlProps.autoplayTime"
    :items="mgnlProps.items"
    :image-load-type="mgnlProps.imageLoadType as ('eager' | 'lazy')"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { TileDisplayBuilder, WrapperProps } from '~/components/Shared/TileDisplay/TileDisplay.model';

const props = defineProps(WrapperProps);

const mgnlProps = TileDisplayBuilder.build(props);
</script>
